import styled from 'styled-components';
import { transition } from '../themes/mainTheme';

export const StyledUpgradePagesTile = styled.div<{
  $isFullWidth?: boolean,
  $canHover?: boolean,
  $isHorizontal?: boolean,
}>`
  color: ${props => props.theme.text.primary};
  font-family: ${props => props.theme.font};

  display: flex;
  flex-direction: ${({ $isHorizontal }) => $isHorizontal ? 'row' : 'column'};
  gap: 8px;
  width: ${({ $isFullWidth }) => $isFullWidth ? '100%' : '320px'};
  border: 1px solid ${props => props.theme.border.decorative};
  padding: 20px;
  border-radius: 2px;
  transition: ${transition('box-shadow')};
  &:hover {
    box-shadow: ${props => props.$canHover ? props.theme.upgradePages.boxShadow : 'none'};
  }
  &:focus-within {
    box-shadow: ${props => props.$canHover ? props.theme.upgradePages.focus.shadow : 'none'};
  }
`;

export const IconWrapper = styled.div<{
  $isHorizontal?: boolean,
}>`
  display: ${({ $isHorizontal }) => $isHorizontal ? 'flex' : 'block'};
  align-items: ${({ $isHorizontal }) => $isHorizontal ? 'center' : 'flex-start'};

  span {
    height: ${({ $isHorizontal }) => $isHorizontal ? '60px' : '50px'};
    width: 50px;
    display: flex;
    align-items: center;
    &:before {
      font-size: ${({ $isHorizontal }) => $isHorizontal ? '40px' : '50px'};
    }
  }
`;

export const TileTitle = styled.h5`
  font-family: ${props => props.theme.font};

  color: ${props => props.theme.text.primary};
  margin: 0;
`;

export const TileDescription = styled.p`
  font-family: ${props => props.theme.font};

  color: ${props => props.theme.text.secondary};
  margin: 0;
`;

export const ContentWrapper = styled.div<{
  $isHorizontal?: boolean,
}>`
  display: flex;
  flex-direction: column;
  margin: ${({ $isHorizontal }) => $isHorizontal ? 'auto 0px' : '0px'};
  gap: ${({ $isHorizontal }) => $isHorizontal ? '0px' : '8px'};
`;
